import React, { createContext, useContext, useState, useCallback } from 'react';

const FlashBarContext = createContext();

export const useFlashBar = () => {
    return useContext(FlashBarContext);
};

export const FlashBarProvider = ({ children }) => {
    const [flashes, setFlashes] = useState([]);

    const showFlash = useCallback(({ type, message, id: customId }) => {
        const id = customId || Date.now().toString() + Math.random().toString(36).substr(2, 9);
        
        setFlashes(prev => {
            // Prevent duplicate messages with same text and type
            if (prev.some(f => f.message === message && f.type === type)) {
                return prev;
            }
            return [...prev, { id, type, message }];
        });

        // Success and Info messages auto-dismiss
        if (type === 'success' || type === 'info') {
            setTimeout(() => {
                dismissFlash(id);
            }, 5000);
        }
        
        return id;
    }, []);

    const dismissFlash = useCallback((id) => {
        setFlashes(prev => prev.filter(f => f.id !== id));
    }, []);

    const clearAll = useCallback(() => {
        setFlashes([]);
    }, []);

    return (
        <FlashBarContext.Provider value={{ showFlash, dismissFlash, clearAll, flashes }}>
            {children}
        </FlashBarContext.Provider>
    );
};
